<template>
	<div class="map">
		<leaflet-map
			ref="map"
			:bounds="bounds"
			:animate="animate"
			v-on="$listeners"
		>
			<leaflet-layer :layer="tileLayer" />
			<slot />
		</leaflet-map>
		<slot name="modal"/>
	</div>
</template>

<script>
import LeafletMap from './leaflet/LeafletMap';
import LeafletLayer from './leaflet/LeafletLayer';
import L from 'leaflet';

export default {
	name: 'TMap',
	components: {
		LeafletMap,
		LeafletLayer
	},
	props: {
		/**
		 * Map bounds
		*/
		bounds: { type: [ Array, Object ], },
		/**
		 * Map animate bounds (flyToBounds (animated) or fitBounds (not animated))
		*/
		animate: { type: Boolean, default: true },
		/**
		 * Data containing layer source and attribution.
		*/
		tileData: {
			type: Object,
			default: () => ({
				url: 'https://{s}.maps.timpex.cloud/styles/5dde542e-1dba-4b50-b432-3fa8cec16cbe/{z}/{x}/{y}.png',
				// url: 'https://api.maptiler.com/maps/bright/{z}/{x}/{y}.png?key=tdTrAEFi63dRbJyWnFMT',
				attribution: '&copy; MapTiler &copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors'
			})
		}
	},
	computed: {
		tileLayer() {
			return L.tileLayer(this.tileData.url, { attribution: this.tileData.attribution });
		},
	},
	methods: {
		zoomToBounds() {
			if (this.$refs.map)
				this.$refs.map.zoomToBounds();
		}
	}
};
</script>

<style lang="scss" scoped>

.map {
	width: 100%;
	height: 100%;
}
</style>
